import { useEffect, useRef } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { Button, Form, message, Modal, Upload, UploadFile, Image } from 'antd'
import { YHModal } from '@/components/YHModal'
import { baseMaintenanceTechnicianModel } from '../maintenanceTechnicianModel'
import { globalPrompt } from '@/components/message'
import { maintenanceTechnicianService } from '../maintenanceTechnicianService'
import { UserAddOutlined, UserOutlined } from '@ant-design/icons'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadChangeParam } from 'antd/lib/upload'

export const EditMaintenanceTechnicianModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = baseMaintenanceTechnicianModel()
    const formRef = useRef<IYhFormRef>()
    // const [formVal, setFormVal] = useState<any>({})

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            const { fileList = [] } = val
            const reqData = {
                ...editCarVisible.value,
                ...val,
            }
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    return message.error('文件信息有误，请重新上传文件')
                }
                reqData.md5 = file?.uid
                reqData.photo = file.name
            }
            if (fileList.length === 0) {
                return message.warning(`请补全照片信息，再继续操作！`)
            }
            maintenanceTechnicianService
                .edit({ ...reqData })
                .then((result) => {
                    setEditCarVisible({
                        visible: false,
                        value: {},
                    })
                    message.success(`修改成功！`)
                    loadData()
                    return result
                })
                .catch((err) => {
                    message.warning('修改失败！')
                })
        })
    }

    useEffect(() => {
        let fileList: any = []
        const { md5, photo } = editCarVisible.value
        if (md5) {
            fileList = [
                {
                    uid: md5,
                    status: 'done',
                    name: photo,
                    response: {
                        retData: md5,
                    },
                },
            ]
        }
        editCarVisible.value.fileList = fileList
        formRef.current?.setFieldsValue({ ...editCarVisible.value })
    }, [editCarVisible.value])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
        // setFormVal({ ...formVal, ...val })
    }
    const onPreview = (file: UploadFile<any>) => {
        const { uid } = file
        Modal.info({
            title: '图片查看',
            content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
            okText: '确定',
            cancelText: '取消',
            centered: true,
            width: 800,
        })
    }
    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode === 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }
    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '姓名',
                fieldName: 'driverName',
                span: 24,
                disable: true,
                rules: [{ required: true, message: '请输入姓名' }],
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '照片',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item name="fileList" label="照片" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }} required>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                                let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif']
                                let isType = filetypes?.includes(fileEnd)
                                if (!isType) {
                                    message.error('不支持该格式的上传,当前仅支持图片类型文件')
                                }
                                return isType
                            }}
                            iconRender={(file) => {
                                return (
                                    // <FontIcon
                                    // onClick={() => {
                                    //     onPreview(file)
                                    // }}
                                    //     style={{ fontSize: '24px' }}
                                    //     type="icon-tupian"
                                    // />
                                    <UserOutlined
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                    />
                                )
                            }}
                        >
                            <Button icon={<UserAddOutlined />}>选择头像上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '公司',
                fieldName: 'company',
                span: 24,
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '驾龄',
            //     fieldName: 'drivingExperience',
            //     span: 24,
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '公司地址',
                fieldName: 'address',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '手机号',
                fieldName: 'phoneNumber',
                span: 24,
                rules: [{ required: true, message: '请输入手机号' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                span: 24,
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        // formValues: formVal,
        onChange,
        boxs: [formItem],
    }
    const onClose = () => {
        globalPrompt('modal', {
            title: '修改维修技师',
            type: 'warning',
            text: '您正在修改的维修技师记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {},
                }),
            cancelText: '继续修改',
            // onCancel: () => {
            //     formRef.current?.resetFields()
            //     return
            // },
        })
    }
    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改维修技师..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
